import { useState } from "react";

/**
 * 会话和用户相关状态 Hook
 */
const useSessionState = () => {
  const [sessionId, setSessionId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [isSessionReady, setIsSessionReady] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('connecting'); // 'connecting' | 'connected' | 'disconnected'
  const [hasUserSentMessage, setHasUserSentMessage] = useState(false);
  const [projectId, setProjectId] = useState(null); // 项目ID，用于 ExpertService 专家会话隔离

  // 重置会话状态
  const resetSessionState = () => {
    setSessionId(null);
    setUserId(null);
    setCurrentUser(null);
    setIsLoggedIn(false);
    setShowRegister(false);
    setIsSessionReady(false);
    setConnectionStatus('connecting');
    setHasUserSentMessage(false);
    setProjectId(null);
  };

  return {
    sessionId,
    setSessionId,
    userId,
    setUserId,
    currentUser,
    setCurrentUser,
    isLoggedIn,
    setIsLoggedIn,
    showRegister,
    setShowRegister,
    isSessionReady,
    setIsSessionReady,
    connectionStatus,
    setConnectionStatus,
    hasUserSentMessage,
    setHasUserSentMessage,
    projectId,
    setProjectId,
    resetSessionState,
  };
};

export default useSessionState;
